import * as React from 'react';
import {
	CheckboxGroup,
	FormCheckConditional,
	TextInput,
	Label
} from '../../../../../components/forms';
import handleNoneOptionAndValidationHOC from '../handleNoneOptionAndValidationHOC';
import NextPreviousButtons from '../../NextPreviousButtons';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const LiverQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		return !props.questionnaire[questionName].isValid;
	};
	return (
		<div className="form-group mb-0">
			<Label>{props.questions[questionName]}</Label>
			<div className="section-base section-bordered mt-1 form-group">
				<CheckboxGroup
					title="Liver, stomach, bladder, kidney, or gastrointestinal disorders, including:"
					className="mb-2"
					checkOptions={[
						{
							name: 'hepatitisBorC',
							label: 'Hepatitis B or C',
							checked: props.questionnaire[questionName].hepatitisBorC,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'cirrhosis',
							label: 'Cirrhosis',
							checked: props.questionnaire[questionName].cirrhosis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'sclerosingCholangitis',
							label: 'Sclerosing cholangitis',
							checked: props.questionnaire[questionName].sclerosingCholangitis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'crohnsDisease',
							label: `Crohn’s disease or ulcerative colitis with any flare-up within
								the past 5 years or any continued use of oral steroid`,
							checked: props.questionnaire[questionName].crohnsDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'bleedingRectum',
							label: 'Rectal bleeding other than diagnosed as hemorrhoids',
							checked: props.questionnaire[questionName].bleedingRectum,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'pancreatitis',
							label: 'Pancreatitis',
							checked: props.questionnaire[questionName].pancreatitis,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'chronicKidneyDisease',
							label: 'Chronic kidney disease or nephritis',
							checked: props.questionnaire[questionName].chronicKidneyDisease,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'bloodInUrine',
							label: 'Blood or protein in urine',
							checked: props.questionnaire[questionName].bloodInUrine,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange
						},
						{
							name: 'gastrointestinalDisorderOther',
							label: 'Other',
							checked: props.questionnaire[questionName].gastrointestinalDisorderOther,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							conditionalChildren: (
								<FormCheckConditional isOpen={props.questionnaire[questionName].gastrointestinalDisorderOther}>
									<TextInput
										labelText="Please specify:"
										name="gastrointestinalDisorderOtherDetails"
										onBlur={props.onQuestionnaireBlur}
										onChange={props.onQuestionnaireChange}
										value={props.questionnaire[questionName].gastrointestinalDisorderOtherDetails}
										className="mb-2"
									/>
								</FormCheckConditional>
							)
						},
						{
							name: 'liverNone',
							label: 'None of the above apply to me',
							checked: props.questionnaire[questionName].liverNone,
							onBlur: props.onQuestionnaireBlur,
							onChange: props.onQuestionnaireChange,
							className: 'border-top pt-2'
						},
					]}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

const questionName = 'liver';
const hocConfig = {
	questionName: questionName,
	otherName: 'gastrointestinalDisorderOther',
	otherDetailsName: 'gastrointestinalDisorderOtherDetails'
};
export default handleNoneOptionAndValidationHOC(LiverQuestion, hocConfig);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/medicalQuestions/medicalQuestion1/LiverQuestion.tsx